import script from "./QuizProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizProgress.vue?vue&type=script&setup=true&lang=js"

import "./QuizProgress.vue?vue&type=style&index=0&id=39c2e1ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c2e1ee"]])

export default __exports__